import React, { useEffect, useState } from "react";
import skuAttributeService from "../../masters/sku-attributes/skuAttributeService";

const AttributeMappingModal = ({ open, onClose, entityId, entityType = "RAW_MATERIAL", onSaved }) => {

  const [attributes, setAttributes] = useState([]);
  const [selected, setSelected] = useState([]);

  // ============================================================
  // LOAD ALL ATTRIBUTES + MAPPED
  // ============================================================
  useEffect(() => {

    const loadData = async () => {

      if (!open || !entityId) return;

      try {
        // All attributes
        const allRes = await skuAttributeService.getAttributesForEntity(entityType);

        // Mapped attributes
        const mappedRes = await skuAttributeService.getMappedAttributes(entityType, entityId);

        if (allRes.success) {
          setAttributes(allRes.data || []);
        }

        if (mappedRes.success) {
          const ids = (mappedRes.data || []).map(a => a.attribute_id);
          setSelected(ids);
        }

      } catch (err) {
        console.error("Error loading mapping data", err);
      }
    };

    loadData();

  }, [open, entityId]);

  // ============================================================
  // TOGGLE CHECKBOX
  // ============================================================
  const toggleAttribute = (id) => {

    if (selected.includes(id)) {
      setSelected(selected.filter(x => x !== id));
    } else {
      setSelected([...selected, id]);
    }
  };

  // ============================================================
  // SAVE
  // ============================================================
  const handleSave = async () => {

    try {
      const res = await skuAttributeService.mapAttributes({
        entity_type: entityType,
        entity_id: entityId,
        attribute_ids: selected
      });

      if (!res.success) {
        alert(res.message || "Failed to map attributes");
        return;
      }

      alert("Attributes mapped successfully");

      onSaved?.();
      onClose();

    } catch (err) {
      console.error(err);
      alert("Error saving mapping");
    }
  };

  if (!open) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>

        <h5>Map Attributes</h5>

        <div style={{ maxHeight: "300px", overflowY: "auto" }}>
          {attributes.map(attr => (
            <div key={attr.id}>
              <label>
                <input
                  type="checkbox"
                  checked={selected.includes(attr.id)}
                  onChange={() => toggleAttribute(attr.id)}
                />
                {" "}
                {attr.attribute_name}
              </label>
            </div>
          ))}
        </div>

        <div style={styles.footer}>
          <button onClick={onClose}>Cancel</button>
          <button onClick={handleSave}>Save</button>
        </div>

      </div>
    </div>
  );
};

export default AttributeMappingModal;


// ============================================================
// STYLES
// ============================================================
const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 3000
  },
  modal: {
    background: "#fff",
    padding: 20,
    borderRadius: 8,
    width: 400
  },
  footer: {
    marginTop: 20,
    display: "flex",
    justifyContent: "flex-end",
    gap: 10
  }
};